
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.303 17.25a1 1 0 00.677.26h.13a1.001 1.001 0 00.91-1.09 4.13 4.13 0 00-8.18 0 1 1 0 001.638.858 1 1 0 00.352-.678 1.92 1.92 0 012-1.73h.15a1.91 1.91 0 012 1.73.997.997 0 00.323.65z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.89 50.43c-7.7 0-15.89-2.23-15.89-6.36v-27.7C14 12.23 22.19 10 29.89 10c7.7 0 15.9 2.23 15.9 6.37v27.7c-.04 4.13-8.19 6.36-15.9 6.36zm0-13.42c-8.61 0-13.89-2.54-13.89-4.36V25.23c2.9 2.062 8.514 3.149 13.89 3.149 5.394 0 11.003-1.091 13.9-3.161v7.43c0 1.82-5.29 4.361-13.9 4.361zm0 2c-5.376 0-10.99-1.087-13.89-3.148v8.208c0 1.82 5.28 4.36 13.89 4.36s13.9-2.54 13.9-4.36v-8.221c-2.897 2.07-8.506 3.161-13.9 3.161zm0-12.63c-8.61 0-13.89-2.54-13.89-4.36v-1.948c2.9 2.061 8.514 3.148 13.89 3.148 5.394 0 11.003-1.091 13.9-3.161v1.96c0 1.82-5.29 4.361-13.9 4.361zm0-5.16c-8.61 0-13.89-2.54-13.89-4.36v-.49C16 14.55 21.28 12 29.89 12s13.86 2.58 13.9 4.37v.49c0 1.82-5.29 4.36-13.9 4.36z"}})])
          )
        }
      }
    